<template>
  <v-container fluid>
    <v-tabs>
      <template v-for="(menu, index) in menus" :key="index">
        <v-tab
          v-if="hasPermission(menu.permission)"
          :to="{ name: menu.route }"
        >
          {{ menu.label }}
        </v-tab>
      </template>
    </v-tabs>
    <v-card class="mt-10 transparent">
      <router-view />
    </v-card>
  </v-container>
</template>

<script>

export default {
  components: {
  },
  data() {
    return {
      menus: [
        {
          label: 'NACHA Returns',
          icon: 'mdi-account-group',
          route: 'nacha-returns',
          permission: 'view file-management::nacha-return',
        },
        {
          label: 'NACHA Conversions',
          icon: 'mdi-account-group',
          route: 'nacha-conversions',
          permission: 'view file-management::nacha-conversion',
        },
      ],
    };
  },
};
</script>

<style></style>
